// Shared helper: when a quota-exceeded 402 hits, show a toast that links to /app/billing.
import { toast } from "sonner";

export function handleQuotaError(err, navigate) {
  const status = err?.response?.status;
  const detail = err?.response?.data?.detail;
  if (status !== 402) return false;

  // detail may be: an object {code, message, upgrade_url}, a plain string, or null
  let msg = "You've hit your plan's monthly limit.";
  let upgradeUrl = "/app/billing";
  if (detail && typeof detail === "object") {
    msg = detail.message || msg;
    upgradeUrl = detail.upgrade_url || upgradeUrl;
  } else if (typeof detail === "string") {
    msg = detail;
  }
  toast.error(msg, {
    action: {
      label: "Upgrade",
      onClick: () => navigate(upgradeUrl),
    },
    duration: 8000,
  });
  return true;
}
